const IDEAS = [
  {
    headline: "BLIND GUIDE",
    idea: "What if the product's weaknesses were positioned as features designed specifically for someone who's never seen the category before?",
    color: "#F50078",
  },
  {
    headline: "SNEAK LAUNCH",
    idea: "What if the launch happened in a channel nobody in your category uses — leading to organic discovery before competitors can react?",
    color: "#836DDB",
  },
  {
    headline: "LOYAL STRAY",
    idea: "What if you targeted people who already left a competitor but haven't committed to anything new yet?",
    color: "#1a1a1a",
  },
];

export default function DemoIdeas() {
  return (
    <div className="w-full">
      <div className="stack gap-3 max-w-sm">
        {IDEAS.map((idea, index) => {
          const staggerClass =
            index === 0 ? "scrolly-reveal" : index === 1 ? "scrolly-stagger-1" : "scrolly-stagger-2";

          return (
            <div
              key={idea.headline}
              className={`${staggerClass} border border-black/10 bg-white`}
            >
              <div className="px-5 py-4">
                <div className="flex gap-3 items-start">
                  <span className="text-[10px] text-gray-300 tracking-[0.18em] pt-0.5 shrink-0 tabular-nums font-bold stack uppercase leading-none">
                    IDEA{" "}
                    <span className="type-display text-[1.35rem] font-black text-black/50 leading-none tracking-normal">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </span>
                  <div className="flex-1 stack gap-1.5">
                    <p
                      className="text-[10px] font-bold uppercase tracking-widest"
                    >
                      {idea.headline}
                    </p>
                    <p className="text-sm text-gray-900 leading-normal">{idea.idea}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
